import { enableMapSet } from 'immer';
/**
 * Cases state stores `artifactSet` as a Set; RTK reducers use Immer. This must run on the same
 * immer module as @reduxjs/toolkit before any produce() runs.
 * Rspack `resolve.alias.immer` must point at `immer/dist/immer.mjs` (ESM), not the CJS entry
 * `require.resolve('immer')` would pick — otherwise enableMapSet patches a different instance.
 */ enableMapSet();
